export enum BodySize {
	CUSTOM = 'custom',
	LARGE = 'large',
	MEDIUM = 'medium',
	SMALL = 'small',
}
